exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer[data-v-0d152028] {\n  max-height: 100%;\n  width: 12rem;\n}\n.bug[data-v-0d152028] {\n  padding: 1rem;\n  background: #ffa500;\n  margin: 1rem;\n}\n", ""]);

// exports
